import React from 'react';

/**
 * 统一的"加载更多"按钮（配合 useLoadMore 使用）
 * hasMore 为 false 时不渲染；显示剩余条数，触控目标充足，移动端友好
 */
const LoadMoreButton = ({ hasMore, remaining, onClick }) => {
  if (!hasMore) return null;

  return (
    <div className="text-center mt-6">
      <button
        type="button"
        onClick={onClick}
        className="w-full sm:w-auto px-8 py-3.5 bg-white/80 text-sage-700 border-2 border-sage-300 rounded-xl font-semibold hover:bg-sage-50 hover:border-sage-400 active:bg-sage-100 focus:outline-none focus:ring-2 focus:ring-sage-500 focus:ring-offset-2 transition-all duration-200 shadow-sm"
      >
        加载更多（还有 {remaining} 条）
      </button>
    </div>
  );
};

export default LoadMoreButton;
